export const LOGIN_PAGE_PATH = '/iniciar-sesion';
export const INFORMATION_PATH = '/informacion-general';
export const REGISTER_PAGE_PATH = '/registro';
export const TURNS_PATH = '/reservar-turnos';
export const TURNS_DATE_PATH = '/fechas';
export const HOURS_DATE_PATH = '/horarios';
export const CONFIRM_TURN_PATH = '/confirmar';
export const MY_TURN_PATH = '/mis-turnos';
export const DETAIL_TURN = '/detalle-turno';
export const DOCTORS = '/medicos';
export const HEALTH_INSURANCE = '/obra-sociales';
export const NOTIFICATION_PATH = '/notificaciones';
export const QUESTION_PATH = '/preguntas';
export const QUESTION_NEW_PATH = '/nueva';
export const PROFILE_PATH = '/mi-perfil';
